import { Button } from "@mui/material";
import { useFormContext } from "react-hook-form";

export default function CopyFieldsButton({
  fieldMap,
  label = "Copy from above",
}) {
  const form = useFormContext();

  const handleCopy = () => {
    Object.entries(fieldMap).forEach(([fromField, toField]) => {
      const value = form.getValues(fromField);
      form.setValue(toField, value ?? "", {
        shouldValidate: true,
        shouldDirty: true,
      });
    });
  };

  return (
    <Button variant="outlined" size="small" onClick={handleCopy}>
      {label}
    </Button>
  );
}
